export default __webpack_public_path__ + "static/bunker-phones-2-b461866a26cc9b4afeae3ead4a330164.jpg";